import React from "react";
import DiroLogo from "../assets/powered-by-diro.png";
import { useState } from "react";

const Footer = () => {
	const [mobileWarning, setMobileWarning ]= useState(true)

	const handleCloseWarning = ()=>{
		setMobileWarning(false)
	}
	return (
		<>
		<div className="footer">
			<a className="diro-img-container" href="https://diro.io" target="_blank" rel="noreferrer">
				Powered by
				<img className="diro-img" src={DiroLogo} alt="powered by diro" />
			</a>
		</div>
		{
		mobileWarning &&
		<div className="desktop-optimized">
		<i className="close-mobile-warning" onClick={handleCloseWarning}></i>
		<p> Please use a desktop web browser for an optimized user experience.</p>
		</div>
		}
		
		</>
	);
};

export default Footer;
